export default __webpack_public_path__ + "static/media/paper2img.53dc8575.png";